export const DEFAULT_VERTICALS = "1,2,3,7,8,10";
export const CLAIM_STATUS_ACTIVE = "active";
export const PRIMARY_ADDRESS = "PRIMARY";
